import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import pdfCSS from './pdf.module.css';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Image from 'react-bootstrap/Image';
import writtenLogo from '../../images/skriftlig-logo.png';
import logoImg from '../../images/Logo.png';
import underskrift from '../../images/underskrift.png';

function PdfCertModal({buttonTitle, modalTitle, object, openButtonClass, closeButtonClass, year}) {

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const downloadPDF = () => {
    const capture = document.querySelector('.to-pdf');
    html2canvas(capture).then((canvas) => {
        const imgData = canvas.toDataURL('img/png');
        const doc = new jsPDF('p', 'mm', 'a4');
        const componentWidth = doc.internal.pageSize.getWidth();
        const componentHeight = doc.internal.pageSize.getHeight();
        doc.addImage(imgData, 'PNG', 0, 0, componentWidth, componentHeight);
        doc.save('Service-sertifikat.pdf');
    })
  }

  const {serial_number, customer, product, executed_services} = object.orderedProduct.data.attributes;

  const logo = object.orderedProduct.data.attributes.product.data.attributes.supplier.data.attributes.logo.data;

  const dateString = executed_services.data[0].attributes.service_info.date_performed;
  const date = new Date(dateString);
  const options = {day: '2-digit', month: '2-digit', year: 'numeric'};
  const formattedDate = date.toLocaleDateString('no-NO', options);

  return (
    <>
            <Button className={openButtonClass} variant="primary" onClick={handleShow}>
                {buttonTitle}
            </Button>

            <Modal show={show} onHide={handleClose} size="lg" dialogClassName={pdfCSS.modalWidth}>
                <Modal.Header closeButton>
                <Modal.Title>{modalTitle} Sertifikat</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="to-pdf">
                        <div className={pdfCSS.filler}></div>
                        <div className={pdfCSS.container1}>
                            <div className={pdfCSS.topRow}>
                                <div className={pdfCSS.supplier}>
                                    {logo ? (
                                        <Image fluid alt="logo" src={logo.attributes.url} />
                                    ) : (
                                        <span>{product.data.attributes.supplier.data.attributes.name}</span>
                                    )}
                                </div>
                                <div className={pdfCSS.vp}>
                                    <div className={pdfCSS.logo}>
                                        <div className={pdfCSS.logoImg}>
                                            <Image fluid alt="vp-logo" src={logoImg}/>
                                        </div>
                                        <div className={pdfCSS.writtenLogo}>
                                            <Image fluid alt="vp-logo" src={writtenLogo}/>
                                        </div>
                                    </div>
                                    <div className={pdfCSS.vpInfo}>
                                        <p>Org.nr: 948 636 778</p>
                                        <p>Tuenveien 80, 2000 Lillestrøm</p>
                                        <p>ab@verktoypartner.no</p>
                                    </div>
                                </div>
                            </div>
                            <div className={pdfCSS.container3}>
                                <p className={pdfCSS.p2}>
                                    KONTROLLSERTIFIKAT
                                </p>
                                <p className={pdfCSS.p2}>
                                    {year}
                                </p>
                            </div>
                            <div className={pdfCSS.container4}>
                                <p className={pdfCSS.p3}>
                                    DETTE BEVITNER AT
                                </p>
                                <p className={pdfCSS.p4}>{customer.data.attributes.username}</p>
                                {/* {product.data.attributes.name} */}
                                <p className={pdfCSS.p3}>
                                    HAR UTFØRT KONTROLLINSPEKSJONEN
                                </p>
                                <p className={pdfCSS.p3}>
                                    OG AT UTSTYRET ER I HENHOLD TIL FABRIKANTENS STANDARD.
                                </p>
                            </div>
                            <div className={pdfCSS.container5}>
                                <p className={pdfCSS.p5}>SERTIFIKATET GJELDER FOR SERIENUMMER: {serial_number} </p>
                                <p className={pdfCSS.p5}>OG ER GJENNOMFØRT DATO: {formattedDate}</p>
                            </div>
                            <div className={pdfCSS.container6}>
                                <div className={pdfCSS.signatur}>
                                    <Image fluid alt="underskrift" src={underskrift} />
                                </div>
                                <p className={pdfCSS.p5}>SERVICEANSVARLIG</p>
                            </div>
                        </div>
                        <div className={pdfCSS.filler}></div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                <Button className={pdfCSS.downloadButton} onClick={downloadPDF}>Last ned</Button>
                <Button className={closeButtonClass} variant="primary" onClick={handleClose}>
                    Lukk
                </Button>
                </Modal.Footer>
            </Modal>
    </>
  );
}

export default PdfCertModal;